/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints, typography2 } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';
import { useDegreeDescriptionPageData } from 'bundles/degree-description/contexts/DegreeDescriptionPageContext';
import { useDegreeDescriptionPageTheme } from 'bundles/degree-description/degreeDescriptionPageTheme';
import type { DegreeDescriptionPageTheme } from 'bundles/degree-description/degreeDescriptionPageTheme';

const styles = {
  container: () => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: var(--cds-spacing-200);
    background: var(--cds-color-blue-50);
    ${breakpoints.up('md')} {
      border-radius: 8px;
    }
    ${breakpoints.up('lg')} {
      padding: var(--cds-spacing-400);
    }
  `,
  markdownStyles: (theme: DegreeDescriptionPageTheme) => css`
    .rc-Markdown.styled {
      h2,
      h3,
      h4,
      h5,
      h6,
      p {
        font-family: ${theme.typography.fontFamily};
      }

      h3 {
        ${typography2.subtitleMedium}
      }

      p {
        ${typography2.bodyPrimary};
        ${theme.mobileFontSizeStyle?.body};
      }
    }
  `,
};

type Props = {
  finalDeadlineInfo?: string | null; // Markdown string
};

const DeadlinesBlock = ({ finalDeadlineInfo }: Props) => {
  const theme = useDegreeDescriptionPageTheme();
  const { id } = useDegreeDescriptionPageData();
  const degreeId = id.replace(/^base~/, '');

  if (!finalDeadlineInfo) {
    return null;
  }

  return (
    <div css={[styles.container, styles.markdownStyles(theme)]}>
      <Markdown
        source={finalDeadlineInfo}
        buttonTrackingNameV3="degree_info_link"
        trackingSection="page_header"
        trackingSubSection="admissions_information"
        trackingProductId={degreeId}
      />
    </div>
  );
};

export default React.memo(DeadlinesBlock);
